import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import useOrderData from "@/hooks/data/use-orders-data";
import { IOrder } from "@/interfaces/order.interfaces";
import { OrderObservationMessages } from "@/messages/order-details/order-observation.messages";
import borders from "@/themes/base/borders";

type Props = {
  messages: OrderObservationMessages;
  order: IOrder | null;
};

export default function OrderObservation({ messages, order }: Props) {
  const { orderObservationTitle } = messages;
  const { orderComments1 } = useOrderData({ order });
  const { borderWidth, borderColor } = borders;

  return (
    <>
      <MDTypography variant="h6" fontWeight="medium">
        {orderObservationTitle}
      </MDTypography>

      <MDBox
        border={`${borderWidth[1]} solid ${borderColor}`}
        borderRadius="lg"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={3}
        mt={2}
        sx={{ overflow: "hidden", wordWrap: "break-word", whiteSpace: "normal" }}
      >
        <MDBox width="100%" mr={2}>
          <MDTypography
            variant="h6"
            fontWeight="medium"
            sx={{ overflow: "hidden", wordWrap: "break-word", whiteSpace: "normal" }}
          >
            {orderComments1}{" "}
          </MDTypography>
        </MDBox>

        <MDBox ml="auto" lineHeight={0} />
      </MDBox>
    </>
  );
}
